// App

import React from "react";
import { Routes, Route } from "react-router-dom";

// Screens
// import MeterDashboard from "./pages/meterDashboard";
import ConsumerDashboardMoc from "./pages/consumerDashboardMoc";
import Dashboard360 from "./pages/dashboard360";
import CommandReportDashboard from "./pages/commandReportDashboard";
import BillingDeterminantDashboard from "./pages/billingDeterminantDashboard";
import WalletBalance from "./components/billingDeterminantCards/WalletBalance";
import RegisterRules from "./components/meterCards/RegisterRules";
import RegisterRuleBook from "./components/meterCards/RegisterRuleBook";
import Meters from "./components/meterCards/Meters";
import Reports from "./pages/reports";
import EnergyAuditReport from "./components/allReports/EnergyAuditReport";
import PaymentProcessingDashboard from "./components/billingDeterminantCards/PaymentProcessingDashboard";
import BillGenerationSystem from "./components/billingDeterminantCards/BillGenerationSystem";
import RateScheduleForm from "./components/billingDeterminantCards/RateScheduleForm";
import RateManagementDashboard from "./components/billingDeterminantCards/RateManagementDashboard";
import CollectionsManagementDashboard from "./components/billingDeterminantCards/CollectionsManagementDashboard";
import CommitmentContract from "./components/consumerCards/CommitmentContract";
import ConsumerLocation from "./components/consumerCards/ConsumerLocation";
import ConsumerSite from "./components/consumerCards/ConsumerSite";
import WorkOrders from "./pages/workOrders";
import Events from "./pages/events";
import MeterType from "./components/meterCards/MeterType";
import VeeRuleWorkflow from "./components/vee/VeeRuleWorkflow";
import ProsumerDashboard from "./components/p2p/ProsumerDashboard";
import ProsumerScheduling from "./components/p2p/ProsumerScheduling";
import ConsumerRegistration from "./components/p2p/ConsumerRegistration";
import ServiceProvider from "./components/p2p/ServiceProvider";
import RealTimeDashboard from "./components/p2p/RealTimeDashboard";
import EnergyBlockDashboard from "./components/p2p/EnergyBlockDashboard";

import BillingDeterminantReport from "./components/allReports/BillingDeterminantReport";
import MeterReadingReport from "./components/allReports/MeterReadingReport";
import MonthlyConsumptionReport from "./components/allReports/MonthlyConsumptionReport";
import LoadProfileReport from "./components/allReports/LoadProfileReport";
import DailyDataCollectionReport from "./components/allReports/DailyDataCollectionReport";
import MeterEventReport from "./components/allReports/MeterEventReport";
import VeeExceptionReport from "./components/allReports/VeeExceptionReport";
import BillingReport from "./components/allReports/BillingReport";
import BillingSummary from "./components/allReports/BillingSummary";
import SaidiReport from "./components/allReports/SaidiReport";
import SaifiReport from "./components/allReports/SaifiReport";
import CaidiReport from "./components/allReports/CaidiReport";
import CaifiReport from "./components/allReports/CaifiReport";
import MissingReadsDashboard from "./components/allReports/MissingReadsDashboard";
import EnergyPerformanceReport from "./components/allReports/EnergyPerformanceReport";
import Login from "./pages/login";
import PageNotFound from "./pages/pageNotFound/PageNotFound";

// Protected Route
import ProtectedRoute from "./protectedRoute/ProtectedRoute";
import PublicRoute from "./publicRoute/PublicRoute";
import FieldUtilityService from "./pages/fieldUtilityService";
import CustomerIndexMock from "./components/consumerCardsMoc/ConsumerIndex";
import MeterDashboardMock from "./pages/meterDashboardMock";
import AnalyticsScreen from "./pages/analytics";
import TicketsPage from "./pages/tickets/index";
import TariffsDashboard from "./components/billingDeterminantCards/TariffsDashboard";
import BuildMaterialRuleWorkflow from "./pages/buildMaterialRule";
import NewTariffs from "./pages/newTariffs/index";
import TariffFormV2 from "./pages/newTariffs/TariffFormV2";
import BillingV2 from "./pages/billingV2";
import PaymentsV2 from "./pages/paymentsV2";
import AdjustmentsV2 from "./pages/adjustmentsV2";
import NotificationSettings from "./pages/notificationSettings";

import BasicReportsPage from "./pages/basicReports/BasicReportsPage";
import BasicDashboardPage from "./pages/basicReports/BasicDashboardPage";
import OverviewV2 from "./pages/reportsV2/Overview";
import ConsumptionV2 from "./pages/reportsV2/Consumption";
import RevenueBillingV2 from "./pages/reportsV2/RevenueBilling";
import BillingAnalyticsV2 from "./pages/reportsV2/BillingAnalytics";

// Report & Analytics (migrated smartmeter-frontend)
import RADashboardPage from "./features/reportAnalytics/pages/DashboardPage";
import RATimeSeriesPage from "./features/reportAnalytics/pages/TimeSeriesPage";
import RAAnomalyPage from "./features/reportAnalytics/pages/AnomalyPage";
import RALoadProfilePage from "./features/reportAnalytics/pages/LoadProfilePage";
import RAForecastPage from "./features/reportAnalytics/pages/ForecastPage";
import RAVoltageQualityPage from "./features/reportAnalytics/pages/VoltageQualityPage";
import RAFrequencyPage from "./features/reportAnalytics/pages/FrequencyPage";
import RADemandPeakPage from "./features/reportAnalytics/pages/DemandPeakPage";
import RAEventLogPage from "./features/reportAnalytics/pages/EventLogPage";
import RAComparePage from "./features/reportAnalytics/pages/ComparePage";
import RAUptimePage from "./features/reportAnalytics/pages/UptimePage";
import RASolarPage from "./features/reportAnalytics/pages/SolarPage";

const App: React.FC = () => {
  const wrapWithProtectedRoute = (
    children: React.ReactNode,
  ): React.ReactElement => {
    return <ProtectedRoute>{children}</ProtectedRoute>;
  };

  return (
    <Routes>
      <Route path="/" element={wrapWithProtectedRoute(<Dashboard360 />)} />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      {/* <Route
        path="/meter-dashboard"
        element={wrapWithProtectedRoute(<MeterDashboard />)}
      /> */}
      <Route
        path="/meter-dashboard"
        element={wrapWithProtectedRoute(<MeterDashboardMock />)}
      />
      {/* <Route
        path="/consumer-dashboard"
        element={wrapWithProtectedRoute(<ConsumerDashboard />)}
      /> */}
      <Route
        path="/consumer-360"
        element={wrapWithProtectedRoute(<ConsumerDashboardMoc />)}
      />
      <Route
        path="/dashboard-360"
        element={wrapWithProtectedRoute(<Dashboard360 />)}
      />
      <Route
        path="/read-cluster"
        element={wrapWithProtectedRoute(<CommandReportDashboard />)}
      />

      {/* <Route
        path="/read-cluster-mock"
        element={wrapWithProtectedRoute(<CommandReportDashboardMock />)}
      /> */}
      <Route
        path="/billing-determinant"
        element={wrapWithProtectedRoute(<BillingDeterminantDashboard />)}
      />
      <Route
        path="/wallet-balance"
        element={wrapWithProtectedRoute(<WalletBalance />)}
      />
      <Route
        path="/register-rules"
        element={wrapWithProtectedRoute(<RegisterRules />)}
      />
      <Route
        path="/register-rule-book"
        element={wrapWithProtectedRoute(<RegisterRuleBook />)}
      />
      <Route path="/meters" element={wrapWithProtectedRoute(<Meters />)} />
      {/* <Route path="/consumer" element={wrapWithProtectedRoute(<Customer />)} /> */}
      <Route
        path="/consumer"
        element={wrapWithProtectedRoute(<CustomerIndexMock />)}
      />
      <Route path="/reports" element={wrapWithProtectedRoute(<Reports />)} />
      <Route
        path="/energy-audit-loss-report"
        element={wrapWithProtectedRoute(<EnergyAuditReport />)}
      />
      <Route
        path="/payment-processing-dashboard"
        element={wrapWithProtectedRoute(<PaymentProcessingDashboard />)}
      />
      <Route
        path="/bill-generation-system"
        element={wrapWithProtectedRoute(<BillGenerationSystem />)}
      />
      <Route
        path="/tariff-form"
        element={wrapWithProtectedRoute(<RateScheduleForm />)}
      />
      <Route
        path="/tariffs"
        element={wrapWithProtectedRoute(<TariffsDashboard />)}
      />
      <Route
        path="/new-tariffs"
        element={wrapWithProtectedRoute(<NewTariffs />)}
      />
      <Route
        path="/new-tariffs/form"
        element={wrapWithProtectedRoute(<TariffFormV2 />)}
      />
      <Route
        path="/rate-management-dashboard"
        element={wrapWithProtectedRoute(<RateManagementDashboard />)}
      />
      <Route
        path="/collections-management-dashboard"
        element={wrapWithProtectedRoute(<CollectionsManagementDashboard />)}
      />
      <Route
        path="/commitment"
        element={wrapWithProtectedRoute(<CommitmentContract />)}
      />
      <Route
        path="/location"
        element={wrapWithProtectedRoute(<ConsumerLocation />)}
      />
      <Route path="/site" element={wrapWithProtectedRoute(<ConsumerSite />)} />
      <Route
        path="/workorders"
        element={wrapWithProtectedRoute(<WorkOrders />)}
      />
      <Route path="/events" element={wrapWithProtectedRoute(<Events />)} />
      <Route
        path="/meter-type"
        element={wrapWithProtectedRoute(<MeterType />)}
      />
      <Route
        path="/vee-rule-builder"
        element={wrapWithProtectedRoute(<VeeRuleWorkflow />)}
      />
      <Route
        path="/billing-rule-builder"
        element={wrapWithProtectedRoute(<BuildMaterialRuleWorkflow />)}
      />
      <Route
        path="/prosumer-dashboard"
        element={wrapWithProtectedRoute(<ProsumerDashboard />)}
      />
      <Route
        path="/prosumer-scheduling"
        element={wrapWithProtectedRoute(<ProsumerScheduling />)}
      />
      <Route
        path="/consumer-registration"
        element={wrapWithProtectedRoute(<ConsumerRegistration />)}
      />
      <Route
        path="/service-provider"
        element={wrapWithProtectedRoute(<ServiceProvider />)}
      />
      <Route
        path="/real-time-dashboard"
        element={wrapWithProtectedRoute(<RealTimeDashboard />)}
      />
      <Route
        path="/energy-block-dashboard"
        element={wrapWithProtectedRoute(<EnergyBlockDashboard />)}
      />
      <Route
        path="/billing-determinant-report"
        element={wrapWithProtectedRoute(<BillingDeterminantReport />)}
      />
      <Route
        path="/meter-reading-report"
        element={wrapWithProtectedRoute(<MeterReadingReport />)}
      />
      <Route
        path="/missing-reads-dashboard"
        element={wrapWithProtectedRoute(<MissingReadsDashboard />)}
      />
      <Route
        path="/monthly-consumption-report"
        element={wrapWithProtectedRoute(<MonthlyConsumptionReport />)}
      />
      <Route
        path="/load-profile-report"
        element={wrapWithProtectedRoute(<LoadProfileReport />)}
      />
      <Route
        path="/daily-data-collection-report"
        element={wrapWithProtectedRoute(<DailyDataCollectionReport />)}
      />
      <Route
        path="/meter-event-report"
        element={wrapWithProtectedRoute(<MeterEventReport />)}
      />
      <Route
        path="/vee-exceptions-report"
        element={wrapWithProtectedRoute(<VeeExceptionReport />)}
      />
      <Route
        path="/billing-report"
        element={wrapWithProtectedRoute(<BillingReport />)}
      />
      <Route
        path="/billing-summary"
        element={wrapWithProtectedRoute(<BillingSummary />)}
      />
      <Route
        path="/billing-v2"
        element={wrapWithProtectedRoute(<BillingV2 />)}
      />
      <Route
        path="/payments-v2"
        element={wrapWithProtectedRoute(<PaymentsV2 />)}
      />
      <Route
        path="/adjustments-v2"
        element={wrapWithProtectedRoute(<AdjustmentsV2 />)}
      />
      <Route
        path="/notification-settings"
        element={wrapWithProtectedRoute(<NotificationSettings />)}
      />
      <Route
        path="/saidi-report"
        element={wrapWithProtectedRoute(<SaidiReport />)}
      />
      <Route
        path="/saifi-report"
        element={wrapWithProtectedRoute(<SaifiReport />)}
      />
      <Route
        path="/caidi-report"
        element={wrapWithProtectedRoute(<CaidiReport />)}
      />
      <Route
        path="/caifi-report"
        element={wrapWithProtectedRoute(<CaifiReport />)}
      />
      <Route
        path="/energy-performance-report"
        element={wrapWithProtectedRoute(<EnergyPerformanceReport />)}
      />
      <Route
        path="/field-utility-service"
        element={wrapWithProtectedRoute(<FieldUtilityService />)}
      />
      <Route
        path="/analytics"
        element={wrapWithProtectedRoute(<AnalyticsScreen />)}
      />
      <Route
        path="/tickets"
        element={wrapWithProtectedRoute(<TicketsPage />)}
      />
      <Route
        path="/basic-reports"
        element={wrapWithProtectedRoute(<BasicReportsPage />)}
      />
      <Route
        path="/basic-reports-dashboard"
        element={wrapWithProtectedRoute(<BasicDashboardPage />)}
      />
      <Route
        path="/reports-v2/overview"
        element={wrapWithProtectedRoute(<OverviewV2 />)}
      />
      <Route
        path="/reports-v2/consumption"
        element={wrapWithProtectedRoute(<ConsumptionV2 />)}
      />
      <Route
        path="/reports-v2/revenue-billing"
        element={wrapWithProtectedRoute(<RevenueBillingV2 />)}
      />
      <Route
        path="/reports-v2/billing-analytics"
        element={wrapWithProtectedRoute(<BillingAnalyticsV2 />)}
      />
      {/* Report & Analytics routes */}
      <Route path="/report-analytics/dashboard" element={wrapWithProtectedRoute(<RADashboardPage />)} />
      <Route path="/report-analytics/timeseries" element={wrapWithProtectedRoute(<RATimeSeriesPage />)} />
      <Route path="/report-analytics/anomalies" element={wrapWithProtectedRoute(<RAAnomalyPage />)} />
      <Route path="/report-analytics/load-profile" element={wrapWithProtectedRoute(<RALoadProfilePage />)} />
      <Route path="/report-analytics/forecast" element={wrapWithProtectedRoute(<RAForecastPage />)} />
      <Route path="/report-analytics/voltage" element={wrapWithProtectedRoute(<RAVoltageQualityPage />)} />
      <Route path="/report-analytics/frequency" element={wrapWithProtectedRoute(<RAFrequencyPage />)} />
      <Route path="/report-analytics/demand" element={wrapWithProtectedRoute(<RADemandPeakPage />)} />
      <Route path="/report-analytics/events" element={wrapWithProtectedRoute(<RAEventLogPage />)} />
      <Route path="/report-analytics/compare" element={wrapWithProtectedRoute(<RAComparePage />)} />
      <Route path="/report-analytics/uptime" element={wrapWithProtectedRoute(<RAUptimePage />)} />
      <Route path="/report-analytics/solar" element={wrapWithProtectedRoute(<RASolarPage />)} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default App;
